/** Crockford-style legacy lobby codes (pre city-name rollout). */
const LEGACY_CODE_RE = /^[A-HJ-NP-Z2-9]{6}$/i;
/**
 * Two hundred unique city names used as lobby codes.
 * English letters and spaces only; each name is at most 12 characters.
 */
export const LOBBY_CITY_CODES = [
    "Tokyo",
    "London",
    "Paris",
    "Berlin",
    "Moscow",
    "Cairo",
    "Lima",
    "Oslo",
    "Rome",
    "Madrid",
    "Seoul",
    "Taipei",
    "Manila",
    "Dublin",
    "Warsaw",
    "Prague",
    "Vienna",
    "Athens",
    "Helsinki",
    "Lisbon",
    "Zurich",
    "Geneva",
    "Milan",
    "Naples",
    "Venice",
    "Florence",
    "Munich",
    "Hamburg",
    "Cologne",
    "Dresden",
    "Leipzig",
    "Bonn",
    "Stuttgart",
    "Boston",
    "Denver",
    "Austin",
    "Miami",
    "Dallas",
    "Phoenix",
    "Seattle",
    "Portland",
    "Atlanta",
    "Detroit",
    "Memphis",
    "Nashville",
    "Raleigh",
    "Buffalo",
    "Orlando",
    "Tampa",
    "Tucson",
    "Fresno",
    "Oakland",
    "Irvine",
    "Anaheim",
    "Sacramento",
    "Calgary",
    "Edmonton",
    "Winnipeg",
    "Quebec",
    "Halifax",
    "Victoria",
    "Hamilton",
    "Windsor",
    "Sydney",
    "Melbourne",
    "Brisbane",
    "Perth",
    "Canberra",
    "Auckland",
    "Wellington",
    "Christchurch",
    "Dunedin",
    "Singapore",
    "Bangkok",
    "Jakarta",
    "Hanoi",
    "Saigon",
    "Penang",
    "Jaipur",
    "Mumbai",
    "Delhi",
    "Chennai",
    "Kolkata",
    "Hyderabad",
    "Ahmedabad",
    "Colombo",
    "Karachi",
    "Lahore",
    "Dubai",
    "Riyadh",
    "Jeddah",
    "Muscat",
    "Doha",
    "Kuwait",
    "Manama",
    "Beirut",
    "Amman",
    "Baghdad",
    "Tehran",
    "Kabul",
    "Tashkent",
    "Almaty",
    "Bishkek",
    "Yerevan",
    "Tbilisi",
    "Baku",
    "Ankara",
    "Izmir",
    "Antalya",
    "Luxor",
    "Nairobi",
    "Lagos",
    "Accra",
    "Dakar",
    "Rabat",
    "Tunis",
    "Algiers",
    "Tripoli",
    "Khartoum",
    "Kampala",
    "Lusaka",
    "Harare",
    "Gaborone",
    "Maputo",
    "Abuja",
    "Libreville",
    "Windhoek",
    "Maseru",
    "Mbabane",
    "Antananarivo",
    "Port Louis",
    "Reykjavik",
    "Bergen",
    "Trondheim",
    "Gothenburg",
    "Malmo",
    "Tallinn",
    "Riga",
    "Vilnius",
    "Bratislava",
    "Ljubljana",
    "Zagreb",
    "Sarajevo",
    "Skopje",
    "Tirana",
    "Sofia",
    "Bucharest",
    "Budapest",
    "Belgrade",
    "Podgorica",
    "Pristina",
    "Chisinau",
    "Kiev",
    "Minsk",
    "Samara",
    "Kazan",
    "Novosibirsk",
    "Vladivostok",
    "Irkutsk",
    "Krasnoyarsk",
    "Omsk",
    "Perm",
    "Volgograd",
    "Sochi",
    "Ashgabat",
    "Dushanbe",
    "Ulaanbaatar",
    "Pyongyang",
    "New York",
    "San Diego",
    "Las Vegas",
    "Hong Kong",
    "Cape Town",
    "Mexico City",
    "Los Angeles",
    "San Antonio",
    "Salt Lake",
    "Kansas City",
    "Albuquerque",
    "Minneapolis",
    "Pittsburgh",
    "Cincinnati",
    "Louisville",
    "Milwaukee",
    "Cleveland",
    "Baltimore",
    "Richmond",
    "Norfolk",
    "Charleston",
    "Savannah",
    "Oklahoma",
    "Anchorage",
    "Honolulu",
    "Boise",
    "Columbus",
    "Indianapolis",
    "Lincoln",
    "Jackson",
    "Hartford",
    "Providence",
];
/** Same pool as {@link LOBBY_CITY_CODES}, shortest names first (then A–Z). */
export const LOBBY_CITY_CODES_BY_LENGTH = [...LOBBY_CITY_CODES].sort((a, b) => a.length - b.length || a.localeCompare(b));
const CODE_BY_LOWER = new Map(LOBBY_CITY_CODES.map((c) => [c.toLowerCase(), c]));
function collapseWhitespace(s) {
    return s.trim().replace(/\s+/g, " ");
}
/** Returns canonical lobby code or null if unknown. Legacy 6-char codes uppercased. */
export function normalizeLobbyCode(input) {
    const collapsed = collapseWhitespace(input);
    if (!collapsed)
        return null;
    if (LEGACY_CODE_RE.test(collapsed))
        return collapsed.toUpperCase();
    const canonical = CODE_BY_LOWER.get(collapsed.toLowerCase());
    return canonical ?? null;
}
export function isKnownLobbyCode(code) {
    return normalizeLobbyCode(code) !== null;
}
/** First city code not present in `taken` (shortest names preferred). */
export function pickAvailableCityCode(taken) {
    for (const city of LOBBY_CITY_CODES_BY_LENGTH) {
        if (!taken.has(city))
            return city;
    }
    return null;
}
/** Socket.IO room name for a lobby code param or canonical code. */
export function lobbySocketRoom(code) {
    const normalized = normalizeLobbyCode(code);
    return normalized ? `lobby:${normalized}` : null;
}
